import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {

  EstadoComponente,
  GeneralTable,
} from "@/shared/components/ui";
import { useGetSolicitudesIngreso } from "@/shared/actions/erp";
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import {
  EstadosSolicitudIngresoEnum,
  IDataProducto,
  SolicitudesIngreso,
} from "@/shared/interfaces";
import { Button, Chip, Grid, Stack, Typography } from "@mui/material";
import { useMemo, useState } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { PermissionsEnum } from "@/auth/interfaces";
import { cellNotFilter, formatDateWithTimeCell, TABLE_CONSTANTS_COLUMS } from "@/shared";
import { useSinSeriesProducto } from "@/store/erp/productos/sinSeriesProductos.store";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";
import { useUiStore } from "@/store/ui";
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";

export default function SolicitudIngresoAprobadasPagina() {
  //useCheckPermissions(PermissionsEnum.api_add_solicitudingreso);
  useCheckPermissions(PermissionsEnum.api_view_solicitudingreso)
  //** store*/
  const listaproducto = useSinSeriesProducto(s => s.listaProducto)
  const handlCargarListaProducto = useSinSeriesProducto(s => s.handleCargarListaProductos)
  const paginatedProductoData = useSinSeriesProducto(s => s.paginatedProductoData)
  const paginatedSample = useSinSeriesProducto(s => s.pagination)
  const setPaginationSample = useSinSeriesProducto(s => s.setPagination)
  const clearSelectedItems = useSinSeriesProducto(s => s.clearSelectedItems)
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const navigate = useNavigate();
  //** state */
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [idSolicitudIngreso, setIdSolicitudIngreso] = useState(false)


  //const [details, setDetails] = useState<IDataProducto[]>([]);
  //*
  const onSaveEdit = () => {
    setConfirmDialog({
      isOpen: true,
      title: '¿Deseas generar la orden de compra?',
      subtitle: 'Confirma para proceder con el proceso.',
      onConfirm() {
        setConfirmDialogIsOpen(false)
        return navigate(`/compras/orden-compras/crear/${idSolicitudIngreso}`)
        //return navigate(`${ROUTER_PATHS.inventario}`)
      },
      onClose() {
        setConfirmDialogIsOpen(false)
      }
    })
  }
  //**columns */
  const columns = useMemo<MRT_ColumnDef<SolicitudesIngreso>[]>(
    () => [
      {
        ...cellNotFilter,
        accessorKey: "detalle",
        header: "Producto",
        size: 20,
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              color="primary"
              onClick={() => onDetails(row.original)}
              startIcon={<VisibilityIcon />}
            >
              {'ver'}
            </Button>

          );
        },
      },

      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_creacion",
        header: "fecha de creacion",
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
      },
      {
        ...cellNotFilter,
        accessorKey: "bodega_data.nombre",
        header: "bodega",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "ubicacion_data.nombre",
        header: "ubicacion",
        size: 200,
      },
      {
        accessorKey: "observaciones.observacionRevision",
        header: "observacion del Revisor",
        //size: 200,
        //Cell: ({ row }) => row.original.observaciones?.observacionRevision || 'N/A'
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
        Cell: ({ row }) => {
          return (
            <ModalObservacionGeneral
              texto={
                row.original.observaciones?.observacionRevision || 'N/A'
              }
              title="Observación del Revisor "
            />
          )
        }
      },
      {
        ...cellNotFilter,
        accessorKey: "user.username",
        header: "Usuario",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "estado_solictud",
        header: "estado",
        size: 200,
        Cell: ({ row }) =>
          row.original.estado_solicitud != null ? (
            <EstadoComponente
              backgroundColor="green"
              texto={row.original.estado_solicitud || ""}
            />
          ) : null,
      },
    ],
    []
  );

  const onDetails = (e: MRT_RowData) => {
    handlCargarListaProducto(e.productos)
    setIdSolicitudIngreso(e.id_solicitudingreso)
    //setDetails(e.productos);
    setIsModalOpen(true);
  };
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<IDataProducto>[] =
    useMemo<MRT_ColumnDef<IDataProducto>[]>(
      () => [
        {
          accessorKey: 'cantidad_aprobada',
          header: "Cant.Aprobada",
          size:145,
          Cell: ({ row }) => {
            const value = row.original.cantidad_aprobada ?? 0;
            const aprobado = Number(value) > 0;

            return (
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="body2">{value}</Typography>
                <Chip
                  label={aprobado ? "Aprobado" : "No aprobado"}
                  color={aprobado ? "success" : "error"}
                  size="small"
                />
              </Stack>
            );
          }
        },
        {
          accessorKey: 'codigo',
          header: 'Código',
          Cell: ({ row }) => row.original?.codigo || 'N/A',
        },
        {
          accessorKey: 'producto_data.descripcion',
          header: 'Descripción',
          Cell: ({ row }: { row: any }) => row.original?.producto_data?.descripcion || 'N/A'
        },
        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'Unidad Medida',
          Cell: ({ row }: { row: any }) => row.original?.producto_data?.unidad_medida || 'N/A'
          //Cell:({row}:{row:MaterialTransferido})=>row.producto_data?.unidad_medida || 'N/A'

        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
        },
      ],
      []
    );

  const {
    pagination,
    searchTerm,
    setPagination,

    dateBefore,
    dateAfter,
    //cleanFilter
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering();

  const {
    data: solicitudPedidoIngresosAprobadasRes,
    isLoading,
    isRefetching,
  } = useGetSolicitudesIngreso({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudIngresoEnum.APROBADAS,
    fecha_after: dateAfter,
    fecha_before: dateBefore,
    numero_referencia: searchTerm,
    ...filterObject,
    filterByState: false,

  });


  return (
    <Grid container spacing={2}>

      <Grid item xs={12}>
        <GeneralTable<SolicitudesIngreso>
          columns={columns}
          data={solicitudPedidoIngresosAprobadasRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidoIngresosAprobadasRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          //
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}

          // crud
          enableColumnActions={true}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn="first"
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Detalle Producto"
        onCloseIcon={() => { setIsModalOpen(false), clearSelectedItems() }}
        minWidth="60%"
        confirmTextBtn={
          <>
            <ShoppingCartIcon />
            Generar Orden Compra
          </>
        }
        confirmVariantBtn={'outlined'}
        onConfirm={() => { onSaveEdit() }}
        contentNode={
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <SampleTablePagination
                columns={columnsProductosDetallePedidosDb}
                data={paginatedProductoData}
                rowCount={listaproducto.length}
                pagination={paginatedSample}
                setPagination={setPaginationSample}
                rowNumber={true}
              />
              {/* {details.length > 0 && (
                  <SampleTable<IDataProducto>
                    columns={columnsProductosDetallePedidosDb}
                    data={details}
                  />
                )} */}
            </Grid>
          </Grid>
        }
      />
    </Grid>
  );
}
